// extracted by mini-css-extract-plugin
export default {"attention":"ModalDateRange_attention__tPvNq"};